import dot from 'dot-prop'
import config from '@config'
import atDe from './lang/at-de.json'
import chDe from './lang/ch-de.json'
import chEn from './lang/ch-en.json'
import chFr from './lang/ch-fr.json'
import siSl from './lang/si-sl.json'
import hrHr from './lang/hr-hr.json'
import deDe from './lang/de-de.json'
import rsSr from './lang/rs-sr.json'
import rsHr from './lang/rs-hr.json'
import baBs from './lang/ba-bs.json'

import atDeVt from './lang/at-de--vt.json'
import chFrVt from './lang/ch-fr--vt.json'
import chDeVt from './lang/ch-de--vt.json'
import deDeVt from './lang/de-de--vt.json'

const debug = false

const langs = {
  'at-de': atDe,
  'ch-de': chDe,
  'ch-en': chEn,
  'ch-fr': chFr,
  'si-sl': siSl,
  'hr-hr': hrHr,
  'de-de': deDe,
  'rs-sr': rsSr,
  'rs-hr': rsHr,
  'ba-bs': baBs,
  'at-de--vt': atDeVt,
  'ch-de--vt': chDeVt,
  'ch-fr--vt': chFrVt,
  'de-de--vt': deDeVt,
}

let currentSet = null
const currentKey = () =>
  `${config.get('local.country')}-${config.get('local.locale')}${config.get('local.suffix') || ''}`
const missing = (key) => `[${key}]`
const decorated = (key, str) => (debug ? `[${key}] ${str}` : str)

const has = (key) => {}

const get = (key, replacer = {}) => {
  if (!currentSet) {
    currentSet = langs[currentKey()]
  }
  const str = dot.get(currentSet, key)

  if (str === '') {
    return null
  }

  let strr = str ? decorated(key, str) : missing(key)
  Object.keys(replacer).map((k) => {
    const v = replacer[k]
    strr = strr.replaceAll(`{{${k}}}`, v)
    return k
  })
  return strr
}

export default get
